var isSameYear = require('../is_same_year/index.js');
/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */


function isThisYear(dirtyDate) {
  return isSameYear(new Date(), dirtyDate);
}

module.exports = isThisYear;